const register = {
  loginCredentials: "ログイン認証情報", // translated
  companyInformation: "企業情報", // translated
  contactDetails: "連絡先の詳細", // translated
  businessName: "商号", // translated
  businessAddress: "職場の住所", // translated
  registrationCode: "登録コード", // translated
  businessRegistrationNumber: "Business Registration Number", // translated
  websiteUrl: "ウェブサイトのURL", // translated
  mobilePhone: "携帯電話", // translated
  regionStateProvince: "地域/州/県", // translated
  legalTitle: "法的所有権", // translated
  city: "市", // translated
  postalCode: "郵便番号", // translated
  registrationSuccess: "登録完了。", // translated
  pleaseWaitFewMomentsAndYouWillBeRedirectedToHome:
    "ホームページにリダイレクトされるので、しばらくお待ちください。", // translated
  usernameEmail: "ユーザー名（メール）", // translated
  password: "パスワード", // translated
  verifyPassword: "パスワード確認", // translated
  documents: "書類", // translated
  termsAndConditionsSection: "利用規約", // translated
  certificateOfIncorporation: "法人設立証明書", // translated
  acceptTermsAndConditions: "利用規約に同意する", // translated
  country: "国", // translated
  brandName: "ブランド名", // translated
  register: "登録", // translated
  isRequired: "必須です", // translated
  passwordMin8Chars: "8文字以上である必要があります", // translated
  passwordRequiresDigit: "数字を1文字以上含める必要があります", // translated
  passwordRequiresLowercase: "小文字を1文字以上含める必要があります", // translated
  passwordRequiresUppercase: "大文字を1文字以上含める必要があります", // translated
  passwordRequiresSpecialChar: '特殊文字を1文字以上含める必要があります (!@#$%^&*(),.?":{}|<>)', // translated
  uploadFile: "ファイルをアップロード", // translated
  filename: "ファイル名:", // translated
  fileType: "種類:", // translated
  fileSize: "サイズ:", // translated
  maxFileSize10Mb: "最大: 10MB", // translated
  supportedFileTypes: "対応ファイル形式:", // translated
  showPassword: "パスワードを表示", // translated
  hidePassword: "パスワードを非表示", // translated
  notAvailable: "該当なし", // translated
  fileSizeInKb: "{{size}} KB", // translated
  mobilePhonePlaceholder: "例: +819012345678", // translated
  websiteUrlPlaceholder: "http://www.example.com", // translated
  loading: "読み込み中...", // translated
  uploadingDocument: "書類をアップロード中...", // translated
  percentUploaded: "{{percent}}% アップロード済み", // translated
  registrationSuccessful: "登録が完了しました。", // translated
  failedToUploadDocument: "書類のアップロードに失敗しました。", // translated
  fieldIsRequired: "{{field}} {{isRequired}}", // translated
  fieldMinLength: "{{field}}は{{min}}文字より長くする必要があります", // translated
  fieldMustBeValidEmail: "{{field}}は有効なメールである必要があります", // translated
  fieldPasswordMinLength: "{{field}}は8文字以上である必要があります", // translated
  fieldPasswordRequiresDigit: "{{field}}は数字を1文字以上含める必要があります", // translated
  fieldPasswordRequiresLowercase: "{{field}}は小文字を1文字以上含める必要があります", // translated
  fieldPasswordRequiresUppercase: "{{field}}は大文字を1文字以上含める必要があります", // translated
  fieldPasswordRequiresSpecialChar:
    '{{field}}は特殊文字を1文字以上含める必要があります (!@#$%^&*(),.?":{}|<>)', // translated
  passwordsDoNotMatch: "{{field}}は{{otherField}}と一致しません", // translated
  fieldBetweenLength: "{{field}}は{{min}}文字から{{max}}文字である必要があります", // translated
  postalCodeBetweenLength: "{{field}}は{{min}}文字から{{max}}文字である必要があります", // translated
  invalidUrlFormat: "URLの形式が無効です", // translated
  invalidEmailFormat: "メールの形式が無効です", // translated
  emailMustMatchUsername: "メールはユーザー名（メール）と同じである必要があります", // translated
  mobilePhoneIsRequired: "携帯電話は必須です", // translated
  certificateFileTooLarge: "法人設立証明書のファイルが大きすぎます", // translated
  termsMustBeAccepted: "利用規約に同意する必要があります", // translated
};


export default register;
